import { Injectable } from '@angular/core';
import {
  PasswordEntity,
  PasswordRecoveryActivateSmsEntity,
  PasswordRecoveryEmailEntity,
  PasswordRecoveryEntity,
  PasswordRecoverySmsEntity,
} from '../config/mail-entity.config';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { PasswordRecoveryManagement } from '../models/password-recovery-management.model';
import { Observable } from 'rxjs';

@Injectable()
export class PasswordService {
  constructor() {}

  changePassword(
    mailboxId: string,
    password: string,
    appBrand: string,
  ): Observable<IEntity<any>> {
    const passwordEntity = EntityManager.createEntity(PasswordEntity, {
      mbxId: mailboxId,
      appBrand,
    });
    passwordEntity.value = { password };
    return EntityManager.saveEntity(passwordEntity);
  }

  getPasswordRecoveryManagement(
    mailboxId: string,
    appBrand: string,
  ): Observable<IEntity<PasswordRecoveryManagement>> {
    return EntityManager.getEntity(PasswordRecoveryEntity, {
      mbxId: mailboxId,
      appBrand,
    });
  }

  setEmailPasswordRecoveryMethod(mbxId: string, mail: string, appBrand: string) {
    return EntityManager.updateEntity(
      EntityManager.createEntity(PasswordRecoveryEmailEntity, {
        mbxId,
        mail,
        appBrand,
      }),
    );
  }

  setSmsPasswordRecoveryMethod(mbxId: string, mobileNbr: string, appBrand: string) {
    return EntityManager.updateEntity(
      EntityManager.createEntity(PasswordRecoverySmsEntity, {
        mbxId,
        mobileNbr,
        appBrand,
      }),
    );
  }

  activateSmsPasswordRecoveryMethod(mbxId: string, token: string, appBrand: string) {
    return EntityManager.updateEntity(
      EntityManager.createEntity(PasswordRecoveryActivateSmsEntity, {
        mbxId,
        token,
        appBrand,
      }),
    );
  }
}
